import dayjs from 'dayjs';

import { RoutePaths } from './constants';

export const getRoute = (route: RoutePaths, id: string | number) => {
  return route.replace(`:id`, id.toString());
};



export const reload = () => {
  window.location.reload();
};
export  const SalesColumns = [  
    { title: "Customer Name", dataIndex: "supplierName", key: "supplierName" },
    { title: "Item Name", dataIndex: "materialName", key: "materialName" },
    { title: "Bundle", dataIndex: "totalBundle", key: "totalBundle" },
    { title: "Loose Pcs.", dataIndex: "totalLoosePcs", key: "totalLoosePcs" },
    { title: "Total Pcs", dataIndex: "totalPcs", key: "totalPcs" },
    { title: "Net Weight", dataIndex: "netWeight", key: "netWeight" },
    { title: "Supplied Weight", dataIndex: "suppliedWeight", key: "suppliedWeight" },
    { title: "Actual Purity", dataIndex: "actualPurity", key: "actualPurity" },
    { title: "Expected Weight", dataIndex: "expectedWeight", key: "expectedWeight" },
    { title: "Item Purity", dataIndex: "purity", key: "purity" },
     {
        title: "Entry Date",
        dataIndex: "entryDateTime",
        key: "entryDateTime",
        render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
      },
    // { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
    { title: "Vehicle Number", dataIndex:"vNumber", key:"vNumber" },   
    { title: "Status", dataIndex: "status", key: "status" },

    // { title: "CreatedOn", dataIndex: "entryDateTime", key: "entryDateTime" }
    
    
  ];

  export  const TolranceWebColumns = [
    { title: "Supplier/Customer Name", dataIndex: "supplierName", key: "supplierName" },
    { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
    { title: "Vehicle Number", dataIndex: "vNumber", key: "vNumber" },
    { title: "Weigh Bridge 1", dataIndex: "weighBridge1", key: "weighBridge1" },
    { title: "Weigh Bridge 2", dataIndex: "weighBridge2", key: "weighBridge2" },
    { title: "Weight Difference", dataIndex: "weightDiff", key: "weightDiff" },
     {
        title: "Entry Date",
        dataIndex: "entryDateTime",
        key: "entryDateTime",
        render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
      },
    { title: "Status", dataIndex: "status", key: "status" },
  ];
  export const  PurchaseReportSalesView = [
    { title: "Supplier Name", dataIndex: "supplierName", key: "supplierName" },
    { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
    { title: "Vehicle Number", dataIndex: "vNumber", key: "vNumber" },
      {
        title: "Entry Date",
        dataIndex: "entryDateTime",
        key: "entryDateTime",
        render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
      },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
    },
    { title: "Dust in Percent", dataIndex: "dust", key: "dust" },
    { title: "Dust in kg", dataIndex: "dustInKg", key: "dustInKg" },
    { title: "NetWeight", dataIndex: "netWeight", key: "netWeight" },
    { title: "Final Net Weight", dataIndex: "finalNetWeight", key: "finalNetWeight" },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
    },
    { title: "Status", dataIndex: "status", key: "status" },
  ]
  export const VehicleColumns = [

      { title: "Supplier/Customer Name", dataIndex: "supplierName", key: "supplierName" },
      { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
      { title: "Vehicle Number", dataIndex: "vNumber", key: "vNumber" },
      { title: "Entry Type", dataIndex: "entryType", key: "entryType" },
  
      {
        title: "Entry Date",
        dataIndex: "entryDateTime",
        key: "entryDateTime",
        render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
      },
      {
        title: "Exit Date",
        dataIndex: "exitDateTime",
        key: "exitDateTime",
        render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
      },
      { title: "Status", dataIndex: "status", key: "status" },
  
    ]


export const dashboardColors = [
  "#4A90E2", // softer blue
  "#66BB6A", // softer green
  "#EF5350", // softer red
  "#FFA726", // softer orange
  "#FFEE58", // softer yellow
  "#AB47BC", // softer purple
  "#8D6E63", // muted brown
  "#26A69A", // teal
  "#616161", // dark gray
  "#D4D4D4", // light gray
];